<template>
    <div>
        <DefaultMenu>
            <template #title>
                Mantenedor de Usuarios
            </template>
     
            <b-button v-b-modal.createModal>
                Crear <b-icon icon="person-plus" font-scale="1"></b-icon>
            </b-button>

            <template #right>
                <b-button
                    @click="modalShowSetting = true"
                    title="Configuración"
                    v-b-tooltip.hover.left
                >
                    <b-icon icon="gear"/>
                </b-button>
            </template>
        </DefaultMenu>
        
        <BaseModal v-model="modalShowSetting" size="lg">
            <UserSetting></UserSetting>
        </BaseModal>
        <!-- Modal -->
        <b-modal id="createModal" title="Crear usuario" class="" size="xl" centered scrollable header-bg-variant="dark"
            v-model="modalShow" hide-footer>

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>

            </template>

            <UserForm></UserForm>
        </b-modal>

    </div>
</template>
<script>
import DefaultMenu from '@/components/shared/Default-menu.vue'
import UserForm from './UserMenu/User-form.vue'
import { EventNames } from '@/plugins/enums/index.js'
import UserSetting from './UserMenu/User-setting.vue';
import BaseModal from '@/components/shared/Base-modal.vue';

export default {
    name: 'UserCreate',

    data() {
        return {
            modalShow: false,
            modalShowSetting: false,
        }
    },

    mounted() {
        this.$eventBus.$on(EventNames.CreateUser, () => {
            this.closeModal();
        });
    },

    components: {
        DefaultMenu,
        UserForm,
        UserSetting,
        BaseModal
    },

    methods: {
        openModal() {
            this.modalShow = true;
        },
        closeModal() {
            this.modalShow = false;
        }
    }

}
</script>
